var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","no-gutters":""}},[_c('facebook-mvp',{attrs:{"player":_vm.player}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }